import { createRouter, createWebHashHistory } from "vue-router";
import HomePage from "../pages/index.vue";
import LocalLogin from "../pages/local-login.vue";
import Login from "../pages/login.vue";
import Repo from "../pages/repos/[owner]/[repo]/index.vue";
import Issues from "../pages/repos/[owner]/[repo]/issues/[index]/index.vue";
import Repos from "../pages/repos/index.vue";
import User from "../pages/user.vue";

const routes = [
  /* eslint-disable @typescript-eslint/no-unsafe-assignment */
  { name: "/", path: "/", component: HomePage },
  { name: "/local-login", path: "/local-login", component: LocalLogin },
  { name: "/login", path: "/login", component: Login },
  {
    name: "/repos/[owner]/[repo]/",
    path: "/repos/:owner/:repo/",
    component: Repo,
    props: true,
  },
  {
    name: "/repos/[owner]/[repo]/issues/[index]/",
    path: "/repos/:owner/:repo/issues/:index/",
    component: Issues,
    props: true,
  },
  { name: "/repos/", path: "/repos/", component: Repos, props: true },
  { name: "/user", path: "/user", component: User, props: true },
];

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes,
});

// Workaround for https://github.com/vitejs/vite/issues/11804
router.onError((err, to) => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
  if (err?.message?.includes?.("Failed to fetch dynamically imported module")) {
    if (localStorage.getItem("vuetify:dynamic-reload")) {
      console.error("Dynamic import error, reloading page did not fix it", err);
    } else {
      console.log("Reloading page to fix dynamic import error");
      localStorage.setItem("vuetify:dynamic-reload", "true");
      location.assign(to.fullPath);
    }
  } else {
    console.error(err);
  }
});

void router.isReady().then(() => {
  localStorage.removeItem("vuetify:dynamic-reload");
});

export default router;
